import "./style.css";
import { useState, useRef } from "react";
import Header from "../../components/Header";
import Controls from "../../components/Controls";
import Cards from "../../components/Cards";
import { musics } from "../../musics";

function Home() {
  const audioRef = useRef(null);

  const [iconBtn, setIconBtn] = useState("pause");
  const [musicsData, setMusicsData] = useState([...musics]);
  const [currentMusic, setCurrentMusic] = useState({
    id: 0,
    title: "",
    artist: "",
  });

  function handleChangeMusic(option) {
    if (!currentMusic.id) {
      return;
    }
    const musicId =
      option === "next" ? currentMusic.id + 1 : currentMusic.id - 1;
    const newMusic = musics.find((music) => music.id === musicId);
    if (!newMusic) {
      return;
    }
    setMusic(newMusic);
  }

  function setMusic(music) {
    audioRef.current.src = music.url;
    setCurrentMusic(music);
    setIconBtn("play");
  }

  return (
    <div className="container">
      <Header />
      <main>
        <h2>The best play list</h2>
        <div className="container-cards">
          {musics.map((music) => (
            <div onClick={() => setMusic(music)} key={music.id}>
              <Cards
                title={music.title}
                cover={music.cover}
                description={music.description}
              />
            </div>
          ))}
        </div>
      </main>
      <Controls
        currentMusic={currentMusic}
        audioRef={audioRef}
        iconBtn={iconBtn}
        setIconBtn={setIconBtn}
        handleChangeMusic={handleChangeMusic}
      />
      <audio ref={audioRef} />
    </div>
  );
}

export default Home;
